import { Check, Clock, Send, X } from "react-feather";
import styles from "./prospectjourney.module.css";
import { Dialog, DialogContent, Tooltip, Accordion, AccordionDetails, AccordionSummary, DialogTitle, DialogContentText, Button, DialogActions } from "@mui/material";
import { useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ProspectJourney = ({ prospect_id, journeys, setLoading, expanded, handleChange, setSnackbarMsg, setSnackbarOpen }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [declinedModalOpen, setDeclinedModalOpen] = useState(false);

    const resendDeclinedLetter = async () => {
        setLoading(true);
        setDeclinedModalOpen(false);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/resend-declined-letter/" + prospect_id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setSnackbarMsg(response?.data?.message);
            setSnackbarOpen(true);
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    return (<Accordion expanded={expanded === "panel3"} onChange={handleChange("panel3")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3bh-content" id="panel3bh-header">
            <div className={`${styles.FormAccoHead}`}>
                <p className={`${styles.FormAccoHeadTitlePro}`}>Prospect Journey</p>
            </div>
        </AccordionSummary>
        <AccordionDetails>
            <div className={`${styles.cardUnderS}`}>
                <div className={`${styles.cardUnderSHead}`}>
                    <div className={`${styles.HeadIcon}`}>
                        <img src="/static/img/tenant-journey.png" alt="" />
                    </div>
                    <div className={`${styles.HeadCon}`}>
                        <p className={`${styles.HeadConTitle}`}>Prospect Journey</p>
                        {journeys?.length > 0 && <p className={`${styles.HeadConText}`}>Prospect Since{" "}{dayjs(journeys[0]?.submitted_at).format("MMM D, YYYY")}</p>}
                    </div>
                </div>
                <div className={`${styles.cardUnderSBody}`}>
                    <ul>
                        {journeys?.map((item) => {
                            let className = "";
                            if (item?.status === 1) {
                                className = `${styles.Completed}`;
                            } else if (item?.status === 2) {
                                className = `${styles.Failed}`;
                            } else {
                                className = `${styles.Ongoing}`;
                            }
                            return (<li key={item.id} className={className}>
                                {item?.status === 1 && (<Tooltip title="Completed">
                                    <span><Check /></span>
                                </Tooltip>)}
                                {item?.status === 0 && (<Tooltip title="Ongoing">
                                    <span><Clock /></span>
                                </Tooltip>)}
                                {item?.status === 2 && (<Tooltip title="Failed">
                                    <span>!</span>
                                </Tooltip>)}
                                <div>
                                    {item?.status === 1 && item?.type === "declined" ? (<p style={{ textTransform: 'capitalize' }}>{item?.description} <Tooltip title="Resend declined letter"><button onClick={(e) => setDeclinedModalOpen(true)}><Send /></button></Tooltip></p>) : (<p style={{ textTransform: 'capitalize' }}>{item?.description}</p>)}
                                    <p className={`${styles.Date}`}>{dayjs(item?.submitted_at).format("MMMM D, YYYY")}</p>
                                </div>
                            </li>);
                        })}
                    </ul>
                </div>
            </div>

            <Dialog
                open={declinedModalOpen}
                fullWidth
                maxWidth="sm"
                onClose={(e) => setDeclinedModalOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="NewPopUp"
            >
                <DialogTitle id="alert-dialog-title">
                    Are you sure you want to re-send declined letter?
                    <button onClick={(e) => setDeclinedModalOpen(false)}>
                        <X />
                    </button>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <div className="ModalFormGroup">
                            <label className="PopupBodyText">This will resend the declined letter to the prospect.</label>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(e) => resendDeclinedLetter()} className="CancelPopupBU">Confirm</Button>
                    <Button onClick={(e) => setDeclinedModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
                </DialogActions>
            </Dialog>
        </AccordionDetails>
    </Accordion>);
};

export default ProspectJourney;